import { GET_ASSET_INVENTORY, FETCH_ASSET_TYPES_REQUEST } from "../types/assetInventory";

const initialState = {
  assets_discovery: [],
  assetTypes: [],
};
const assetInventoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ASSET_INVENTORY:
      return {
        ...state,
        assets_discovery: action.payload,
      };
    case FETCH_ASSET_TYPES_REQUEST:
      return {
        ...state,
        assetTypes: action.payload.asset_types,
      };
    default:
      return state;
  }
};

export default assetInventoryReducer;
